import React, { Component } from "react";
import PaginatedDialogView from "../../components/PaginatedDialog/PaginatedDialogView";
import SharedViewProps from "../../../../../models/types/SharedViewProps";
import DialogTextInputView from "../../components/DialogBase/components/DialogTextInput/DialogTextInputView";
import WorkerInfoViewStyle from './WorkerInfoViewStyle';
import ToggleView from "../../../../components/Toggle/ToggleView";
import TranslationView from "../../../../components/Translation/TranslationView";
import WorkerInfoViewState from "./WorkerInfoViewState";
import DialogAddressPickerView from "../../components/DialogBase/components/DialogAddressPicker/DialogAddressPickerView";
import PaginatedDialogFooterView from "../../components/PaginatedDialog/components/PaginatedDialogFooter/PaginatedDialogFooterView";
import ErrorTextView from "../../../../components/ErrorText/ErrorTextView";

export default class WorkerInfoView extends Component<SharedViewProps, WorkerInfoViewState> {

    private _supportedGenders = ['male', 'female'];
    private _supportedLanguages = ['fr', 'nl', 'en', 'de'];
    private _style = new WorkerInfoViewStyle();

    constructor(props : SharedViewProps) {
        super(props);

        this.state = {
            firstName : '',
            lastName : '',
            address : '',
            phoneNumber : '',
            workerFunction : '',
            gender : '',
            languages : [],
            errors : {
                firstName : '',
                lastName : '',
                address : '',
                gender : '',
                languages : '',
                phoneNumber: ''
            }
        };
    }

    private _onFirstNameChange = (firstName : string) => {
        let { errors } = this.state;

        errors.firstName = '';
        this.setState({ firstName, errors });
    }

    private _onLastNameChange = (lastName : string) => {
        let { errors } = this.state;

        errors.lastName = '';
        this.setState({ lastName, errors });
    }

    private _onAddressChange = (address : string) => {
        let { errors } = this.state;

        errors.address = '';
        this.setState({ address, errors });
    }

    private _onPhoneNumberChange = (phoneNumber : string) => {
        let { errors } = this.state;

        errors.phoneNumber = '';
        this.setState({ phoneNumber });
    }

    private _onFunctionChange = (workerFunction : string) => {
        this.setState({ workerFunction });
    }

    private _onGenderChange = (gender : string) => {
        let { errors } = this.state;

        if (this.state.gender !== gender) {
            errors.gender = '';
            this.setState({ gender, errors });
        }
    }

    private _onLanguagesChange = (language : string) => {
        const { languages, errors } = this.state;
        const index = languages.indexOf(language);

        if (index !== -1) {
            languages.splice(index, 1);
        }

        else {
            languages.push(language);
        }

        errors.languages = '';
        this.setState({ languages, errors });
    }

    private _onSubmit = (done : () => void) => {
        const { firstName, lastName, address, phoneNumber, workerFunction, gender, languages, errors } = this.state;

        // Checks if all required fields are filled
        if (!firstName || !lastName || !address || !gender || languages.length === 0) {
            errors.firstName = !firstName ? 'requiredField' : '';
            errors.lastName = !lastName ? 'requiredField' : '';
            errors.address = !address ? 'requiredField' : '';
            errors.gender = !gender ? 'requiredField' : '';
            errors.phoneNumber = !phoneNumber ? 'requiredField' : '';
            errors.languages = languages.length === 0 ? 'requiredField' : '';

            this.setState({ errors });
            done();

            return;
        }

        this.props.routeProps.history.push('injury-info', {
            firstName, lastName, address, phoneNumber, function: workerFunction, gender, languages
        });
    }

    render() {
        const { errors } = this.state;
        return (
            <PaginatedDialogView title='oneShotCheckRequest' subtitle='workerInfo'>
                <div style={this._style.form}>
                    <div style={this._style.row}>
                        <DialogTextInputView placeholder='firstNamePlaceholder' style={this._style.inputMargin} onChange={this._onFirstNameChange} error={errors.firstName} />
                        <DialogTextInputView placeholder='lastNamePlaceholder' onChange={this._onLastNameChange} error={errors.lastName} />
                    </div>

                    <DialogAddressPickerView
                        label='addressPlaceholder'
                        onChange={this._onAddressChange}
                        value={this.state.address}
                        error={errors.address} />

                    <div style={this._style.row}>
                        <DialogTextInputView error={errors.phoneNumber} placeholder='gsmPlaceholder' style={this._style.inputMargin} onChange={this._onPhoneNumberChange} />
                        <DialogTextInputView placeholder='functionPlaceholder' onChange={this._onFunctionChange} />
                    </div>

                    <div style={this._style.row}>
                        {/* GENDER */}
                        <div style={{ ...this._style.inputMargin, flex : 1 }}>
                            <TranslationView style={this._style.label}>
                                genderPlaceholder
                            </TranslationView>

                            <div style={{ display : 'flex' }}>
                                {this._supportedGenders.map(gender => (
                                    <ToggleView text={gender} selected={this.state.gender === gender} onClick={() => this._onGenderChange(gender)} />
                                ))}
                            </div>

                            <ErrorTextView error={errors.gender} /> 
                        </div>

                        {/* LANGUAGE  */}
                        <div style={{ flex : 1 }}>
                            <TranslationView style={this._style.label}>
                                languagesPlaceholder
                            </TranslationView>

                            <div style={{ display : 'flex' }}>
                                {this._supportedLanguages.map(lang => (
                                    <ToggleView text={lang} selected={this.state.languages.includes(lang)} onClick={() => this._onLanguagesChange(lang)} />
                                ))}
                            </div>

                            <ErrorTextView error={errors.languages} />
                        </div>
                    </div>
                </div>

                <PaginatedDialogFooterView numberOfPages={5} currentPage={2} onSubmit={this._onSubmit} />
            </PaginatedDialogView>
        );
    }
}